import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../Sidebar';
import Header from '../Header';
import { useAuth } from '../context/AuthContext';
import ClientReturnDebitsTab from '../components/ClientReturnDebitsTab';

const ReturnDebitsProcessDefinition: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  // This would be the client ID - you might want to pass it from the URL or context
  const clientId = '1'; // Replace with actual client ID

  return (
    <>
      <Sidebar 
        isVisible={isSidebarVisible} 
        toggleSidebar={toggleSidebar} 
      />

      <div className={`transition-all duration-300 ${isSidebarVisible ? 'ml-64' : 'ml-0'}`}>
        <Header 
          title="Return Debits Process Definition"
          user={user}
          toggleSidebar={toggleSidebar}
          isSidebarVisible={isSidebarVisible}
          showClientNumber={false}
        />

        <div className="min-h-screen bg-gray-50 p-4 md:p-6">
          <div className="max-w-7xl mx-auto">
            {/* Back Button */}
            <button
              onClick={() => navigate('/process-definitions')}
              className="mb-6 flex items-center text-blue-600 hover:text-blue-800"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              Back to Process Definitions
            </button>

            {/* Return Debits Component */}
            <ClientReturnDebitsTab clientId={clientId} />
          </div>
        </div>
      </div>
    </>
  );
};

export default ReturnDebitsProcessDefinition;